import { tourProps as VCTourProps, tourStepProps as VCTourStepProps } from '../vc-tour';
export const tourProps = () => (Object.assign(Object.assign({}, VCTourProps()), { steps: { type: Array }, prefixCls: { type: String }, current: { type: Number }, type: { type: String }, 'onUpdate:current': Function }));
export const tourStepProps = () => (Object.assign(Object.assign({}, VCTourStepProps()), { cover: { type: Object }, nextButtonProps: {
        type: Object,
    }, prevButtonProps: {
        type: Object,
    }, current: { type: Number }, type: { type: String } }));
